<script lang="ts">
	import type { Category } from "@core/schema/Category.js";
	import { localizePathFromData } from "@core/utils/localizePathFromData.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import { getTranslate } from "../utils/getTranslate.js";
	import translation from "./Services.translations.json" with { type: "json" };
	import Formatted from "./common/Formatted.svelte";
	import IconMedia from "./common/IconMedia.svelte";
	import Link from "./common/Link.svelte";
	import TextWithIcon from "./common/TextWithIcon.svelte";
	import { ButtonVariant } from "./common/getButtonClass.js";

	const {
		category,
	}: {
		category: Category;
	} = $props();

	const translate = getTranslate(translation);

	const { tenant } = getGlobalTemplateProps();
</script>

<div
	class="bg-zms-grey border h-full rounded-2xl duration-300 transition-all justify-between hover:shadow-lg hover:shadow-black/10 hover:-translate-y-1 border-zms-card-border flex flex-col gap-[3.8125rem] p-3 lg:p-6"
>
	<div class="flex flex-col gap-5">
		<div class="bg-zms-blue w-16 h-16 mb-2 rounded-full flex justify-center items-center">
			<IconMedia
				source={category.image}
				alt={category.nameForListing}
				class="w-10 h-10 text-white"
				width={40}
				height={40}
				useCurrentColor={true}
			/>
		</div>
		<span class="font-medium text-lg/[1.2] font-hubot tracking-[-1%] text-zms-blue-dark"
			><Formatted text={category.nameForListing} /></span
		>
		<p class="font-normal text-sm tracking-[-1%] m-0 p-0 text-zms-optical-black">
			<Formatted text={category.descriptionForListing} />
		</p>
	</div>
	<div class="flex justify-start">
		<Link href={localizePathFromData(category.urlSlug, tenant.locale)} variant={ButtonVariant.TransparentWithIcon}>
			<TextWithIcon transparent>{translate("getToKnowMore")}</TextWithIcon>
		</Link>
	</div>
</div>
